import ActivityStatusAliasView from "./ActivityStatusAliasView";

export default ActivityStatusAliasView;